import { makeHttpRequest } from "@/shared";

export const readAllEvents = async () => {
    const response = (
        await makeHttpRequest({
            url: "/events/read/all",
            method: "POST",
        })
    ).data;

    return response.data;
};
